var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userNotLoggedIn)?_c('h3',[_vm._v(" You're not logged in ")]):_vm._e(),_c('div',{attrs:{"id":"firebaseui-auth-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }